import styled, { css } from 'styled-components'
import tw from 'twin.macro'
import { PAGE_TEMPLATE } from '../../services/api/constants'
import { LAYOUT_TEMPLATE } from '../../services/api/types'

export const LocationMapContainer = styled.div`
  min-height: 500px;
  ${tw`relative w-full h-6`}

  & .mapboxgl-marker svg {
    ${tw`text-orange h-6 w-6`}
  }
`

export const MapPopupWrapper = styled.div<{ template?: LAYOUT_TEMPLATE }>`
  ${tw`text-blue text-lg text-left font-display font-bold flex flex-row h-full self-stretch items-stretch`}

  ${props =>
    props.template === PAGE_TEMPLATE.YOU_FITNESS &&
    css`
      ${tw`text-blue__deep`}

      ${Arrow} {
        ${tw`bg-blue__deep`}
      }

      ${PopupLink} {
        ${tw`bg-white__deep`}
      }
    `}
`
export const PopupLink = styled.a`
  ${tw`flex-1 flex  flex-row items-center px-2`}
`

export const Arrow = styled.a`
  ${tw`bg-orange h-full text-white text-center text-lg flex  flex-row items-center px-2 py-4`}
  &:before {
    content: ' \\276D';
  }
`

export const ToggleMapButton = styled.div`
  ${tw`absolute w-full text-center md:text-right`}
  top: 0.7rem;
  right: 0rem;
  @media (min-width: 768px) {
    right: 0.7rem;
  }
`

export const MapContainerStyled = {
  width: '100%',
  height: '100%',
  overflow: 'hidden'
}
